import { Dialog as Dialog$1 } from '@primer/react';
import sx from '../sx.js';
import styled from 'styled-components';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

const StyledDialog = styled(Dialog$1).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "Dialog__StyledDialog",
  componentId: "sc-19zph8h-0"
})(["", ""], sx);
const DialogImpl = /*#__PURE__*/forwardRef(function Dialog({
  as,
  ...props
}, ref) {
  return /*#__PURE__*/jsx(StyledDialog, {
    ref: ref,
    ...(as ? {
      forwardedAs: as
    } : {}),
    ...props
  });
});
const StyledDialogHeader = styled(Dialog$1.Header).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "Dialog__StyledDialogHeader",
  componentId: "sc-19zph8h-1"
})(["", ""], sx);
const DialogHeader = /*#__PURE__*/forwardRef(function DialogHeader({
  as,
  ...props
}, ref) {
  return /*#__PURE__*/jsx(StyledDialogHeader, {
    ref: ref,
    ...(as ? {
      forwardedAs: as
    } : {}),
    ...props
  });
});
const StyledDialogBody = styled(Dialog$1.Body).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "Dialog__StyledDialogBody",
  componentId: "sc-19zph8h-2"
})(["", ""], sx);
const DialogBody = /*#__PURE__*/forwardRef(function DialogBody({
  as,
  ...props
}, ref) {
  return /*#__PURE__*/jsx(StyledDialogBody, {
    ref: ref,
    ...(as ? {
      forwardedAs: as
    } : {}),
    ...props
  });
});
const StyledDialogFooter = styled(Dialog$1.Footer).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "Dialog__StyledDialogFooter",
  componentId: "sc-19zph8h-3"
})(["", ""], sx);
const DialogFooter = /*#__PURE__*/forwardRef(function DialogFooter({
  as,
  ...props
}, ref) {
  return /*#__PURE__*/jsx(StyledDialogFooter, {
    ref: ref,
    ...(as ? {
      forwardedAs: as
    } : {}),
    ...props
  });
});
DialogHeader.__SLOT__ = Dialog$1.Header.__SLOT__;
DialogBody.__SLOT__ = Dialog$1.Body.__SLOT__;
DialogFooter.__SLOT__ = Dialog$1.Footer.__SLOT__;
const Dialog = Object.assign(DialogImpl, {
  __SLOT__: Dialog$1['__SLOT__'],
  Buttons: Dialog$1.Buttons,
  Header: DialogHeader,
  Body: DialogBody,
  Footer: DialogFooter
});

export { Dialog };
